export enum TemplatePublishingStatus {
    INIT = "INIT",
    PUBLISHED = "PUBLISHED",
    ACTIVE = "ACTIVE",
    ARCHIVED = "ARCHIVED",
    DELETED = "DELETED"
}
